<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15.1519 3.95156c-.225.22504-.3514.53021-.3514.8484 0 .3182.1264.62337.3514.8484l2.7516 2.7516h-6.7032c-2.22783 0-4.3644.885-5.9397 2.46034-1.57531 1.5753-2.46031 3.7118-2.46031 5.9397v2.4c0 .3182.12643.6234.35147.8485.22505.225.53027.3515.84853.3515s.62349-.1265.84853-.3515c.22505-.2251.35147-.5303.35147-.8485v-2.4c0-1.5913.63214-3.1175 1.75736-4.2427S9.60899 10.8 11.2003 10.8h6.7032l-2.7516 2.7516c-.1146.1107-.206.2431-.2689.3895-.0629.1464-.096.3038-.0974.4632-.0014.1593.029.3173.0893.4648.0603.1475.1494.2815.2621.3941.1127.1127.2467.2018.3941.2621.1475.0604.3055.0907.4649.0894.1593-.0014.3168-.0345.4632-.0974.1464-.0629.2788-.1543.3895-.2689l4.8-4.8c.225-.2251.3513-.53024.3513-.84844 0-.31819-.1263-.62336-.3513-.8484l-4.8-4.8c-.225-.22496-.5302-.35134-.8484-.35134-.3182 0-.6234.12638-.8484.35134Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M14.2929 3.29289c-.3905.39053-.3905 1.02369 0 1.41422L18.5858 9H11c-2.38695 0-4.67613.94821-6.36396 2.636C2.94821 13.3239 2 15.6131 2 18v2c0 .5523.44772 1 1 1s1-.4477 1-1v-2c0-1.8565.7375-3.637 2.05025-4.9497C7.36301 11.7375 9.14348 11 11 11h7.5858l-4.2929 4.2929c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0l6-6c.3905-.3905.3905-1.02368 0-1.41421l-6-6c-.3905-.39052-1.0237-.39052-1.4142 0Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
